module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-list', {
    staticClass: "mb-4 pb-0"
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t('subheaders.current')))]), _vm._v(" "), _vm._l((_vm.versions), function(version, index) {
    return [(index === 1) ? _c('v-subheader', {
      key: ("sh-" + (version.VersionId))
    }, [_vm._v("\n        " + _vm._s(_vm.$t('subheaders.older')) + "\n      ")]) : _vm._e(), _vm._v(" "), (version.StorageClass === "GLACIER" && index > 0 && _vm.versions[index - 1].StorageClass !== "GLACIER") ? _c('v-subheader', {
      key: ("sh-" + (version.VersionId))
    }, [_vm._v("\n        " + _vm._s(_vm.$t('subheaders.archived')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
      key: ("tile-" + (version.VersionId)),
      attrs: {
        "disabled": version.StorageClass === "GLACIER"
      }
    }, [_c('v-list-tile-action', [(version.StorageClass !== "GLACIER") ? _c('v-btn', {
      staticClass: "ml-1",
      attrs: {
        "href": version.url,
        "target": "_blank",
        "icon": ""
      }
    }, [_c('v-icon', [_vm._v("cloud_download")])], 1) : _c('v-icon', {
      staticClass: "ml-2",
      attrs: {
        "small": "",
        "disabled": ""
      }
    }, [_vm._v("fiber_manual_record")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            " + _vm._s(_vm.dateformat(version.LastModified)) + "\n          ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            " + _vm._s(_vm.dateformat(version.LastModified, 'HH:mm a')) + "\n          ")])], 1), _vm._v(" "), (version.IsLatest) ? _c('v-list-tile-action', [_c('v-icon', {
      staticClass: "mr-2",
      attrs: {
        "color": "success"
      }
    }, [_vm._v("check")]), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("\n            Latest\n          ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (version.VersionId))
    })]
  }), _vm._v(" "), (_vm.loading) ? _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "indeterminate": "",
      "height": 2
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('v-footer', [_c('span', {
    staticClass: "px-3"
  }, [_vm._v("\n      Please note versions can take a few minutes to update\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d56a26d2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/InvoiceVersions.vue
// module id = 1528
// module chunks = 9